import styled from 'styled-components'
import RouteContainer from '../../../common/styles/RouteContainer'
import RouteTitle from '../../../common/RouteTitle/RouteTitle'
import booksitoutIcon from '../../../config/BooksitoutIcon'
import CardBodyContentContainer from '../../../common/styles/CardBodyContentContainer'
import BookStatisticsByYearCard from './cards/BookStatisticsByYearCard'
import RowSpacer from '../../../common/styles/RowSpacer'
import BookStatisticsReadTimeCard from './cards/BookStatisticsReadTimeCard'
import RouteTitleConfig from '../../../config/RouteTitleConfig'
import useLoginStore from '../../login/useLoginStore'
import Login from '../../../common/Login'
import useHtmlTitle from '../../../common/useHtmlTitle'
import BookStatisticsCategoryCard from './cards/BookStatisticsCategoryCard'
import BookStatisticsLanguageCard from './cards/BookStatisticsLanguageCard'
import BookStatisticsLanguageReadingSpeedCard from './cards/BookStatisticsLanguageReadingSpeedCard'
import BookGoalCard from '../goal/BookGoalCard'
import useBookGoal from '../goal/useBookGoal'
import { useEffect } from 'react'
import useBookGoalStore from '../goal/useBookGoalStore'
import BookStreakCard from '../streak/BookStreakCard'
import useBookStreak from '../streak/useBookStreak'
import BookStatisticsRatingCard from './cards/BookStatisticsRatingCard'
import BookStatisticsReadingSpeedCard from './cards/BookStatisticsReadingSpeedCard'
import BookStatisticsFormCard from './cards/BookStatisticsFormCard'
import BookStatisticsSourceCard from './cards/BookStatisticsSourceCard'
import BookStatisticsDayOfWeekCard from './cards/BookStatisticsDayOfWeekCard'
import BookStatisticsTimeOfDayCard from './cards/BookStatisticsTimeOfDayCard'
import BookStatisticsTopPublishersCard from './cards/BookStatisticsTopPublishersCard'
import BookStatisticsTopAuthorsCard from './cards/BookStatisticsTopAuthorsCard'
import BookStatisticsMonthlyCountCard from './cards/BookStatisticsMonthlyCountCard'
import Footer from '../../../common/Footer'

const BookStatisticsRoute = () => {
	useHtmlTitle('통계')

	const isLoggedIn = useLoginStore(state => state.isLoggedIn())

	return (
		<>
			<RouteContainer>
				<RouteTitle icon={<booksitoutIcon.statistics />} title={'통계'} subTitle={'내 독서활동에 대한 통계를 확인할 수 있어요'} currentKey={'statistics'} buttons={RouteTitleConfig.Book} rightUi={undefined} />

				{isLoggedIn ? <YesLoggedInCase /> : <NoLoggedInCase />}
			</RouteContainer>
			<RowSpacer size={40} />
			<Footer />
		</>
	)
}

const YesLoggedInCase = () => {
	const { init } = useBookGoalStore()
	const [goal, isDone, isGoalLoading] = useBookGoal(new Date().getFullYear())
	useEffect(() => {
		init(goal ? [goal] : [])
	}, [goal])

	const [streakCount, isTodayDone, isStreakLoading] = useBookStreak()

	return (
		<>
			<RowSpacer/>
			<Row>
				<ColTop>
					<a href={'/book/goal'}>
						<CardBodyContentContainer height={100}>
							<BookGoalCard isLoading={isGoalLoading} />
						</CardBodyContentContainer>
					</a>
				</ColTop>

				<ColTop>
					<CardBodyContentContainer height={100}>
						<BookStreakCard streakCount={streakCount} isTodayDone={isTodayDone} isLoading={isStreakLoading} />
					</CardBodyContentContainer>
				</ColTop>

				<ColChart>
					<BookStatisticsReadTimeCard />
				</ColChart>

				<ColSummary>
					<BookStatisticsByYearCard />
				</ColSummary>

				<ColChart>
					<BookStatisticsMonthlyCountCard />
				</ColChart>

				<ColSummary>
					<BookStatisticsRatingCard />
				</ColSummary>

				<ColSummary>
					<BookStatisticsDayOfWeekCard />
				</ColSummary>

				<ColSummary>
					<BookStatisticsTimeOfDayCard />
				</ColSummary>

				<ColSummary>
					<BookStatisticsFormCard />
				</ColSummary>

				<ColSummary>
					<BookStatisticsCategoryCard />
				</ColSummary>

				<ColSummary>
					<BookStatisticsLanguageCard />
				</ColSummary>

				<ColSummary>
					<BookStatisticsLanguageReadingSpeedCard />
				</ColSummary>

				<ColSummary>
					<BookStatisticsSourceCard />
				</ColSummary>

				<ColSummary>
					<BookStatisticsTopPublishersCard />
				</ColSummary>

				<ColSummary>
					<BookStatisticsTopAuthorsCard />
				</ColSummary>

				<ColSummary>
					<BookStatisticsReadingSpeedCard />
				</ColSummary>
			</Row>
		</>
	)
}

const NoLoggedInCase = () => {
	return (
		<>
			<RowSpacer/>
			<CardBodyContentContainer style={{ paddingTop: '40px', paddingBottom: '40px' }}>
				<Login message={'로그인해 내 독서활동 통계 보기'} />
			</CardBodyContentContainer>
		</>
	)
}

const Row = styled.div.attrs({
	className: 'row',
})`
	row-gap: 25px;
`

const ColChart = styled.div.attrs({
	className: 'col-12 col-md-6 col-xl-8',
})``

const ColSummary = styled.div.attrs({
	className: 'col-12 col-md-6 col-xl-4',
})``

const ColHalf = styled.div.attrs({
	className: 'col-12 col-md-6',
})``

const ColTop = styled.div.attrs({
	className: 'col-12 col-lg-6 col-xl-4',
})``

export default BookStatisticsRoute
